import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { updateHome } from "../../../Redux/Slices/home.slice";

const ItemBody19 = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAddFeedback = async () => {
    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));

    dispatch(
      updateTrips({
        key: "driverRatingModal",
        value: {
          visible: true,
          driverName: notification?.metaData?.driverName,
          driverId: notification?.metaData?.driverId,
        },
      }),
    );
    navigate("/users?tab=drivers");
  };

  return (
    <div>
      <p className="font-poppins text-xs font-light">
        Feedback reminder to be added for{" "}
        <span className="capitalize">{notification?.metaData?.driverName}</span>{" "}
      </p>

      <div className="mt-1 w-full flex items-center gap-x-2">
        <button
          type="button"
          className="bg-primary hover:bg-primary-50 py-2 px-4 rounded-md w-full"
          onClick={handleAddFeedback}
        >
          <p className="font-poppins text-xs font-medium text-background-white text-center">
            Add Feedback
          </p>
        </button>
      </div>
    </div>
  );
};

export default ItemBody19;
